var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgArchiveTab = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16",
  width: "1em",
  height: "1em"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#d5d9dd",
  d: "M0 0h16v3.556H0zm.889 4.444H15.11V16H.89zm4.889 2.667a.444.444 0 0 0-.445.445v1.333h5.334V7.556a.445.445 0 0 0-.445-.445z"
})));
export default SvgArchiveTab;